import React, {MouseEvent, useRef} from "react";
import classNames from "classnames";
import styles from "../css/Modal.module.css";
import Icon from "./Icon";
import Box from "./Box";

export interface ModalDialogOptionProps {
    value?: string,
    onClick?: (event: MouseEvent) => void,
    onChange?: (value: File) => void,
    isFileInput?: boolean,
    first?: boolean,
    disabled?: boolean,
    last?: boolean,
    grey?: boolean,
    backgroundColor?: string,
    icon?: string,
    horizontal?: boolean,
    iconMargin?: number
}

export default (props: ModalDialogOptionProps) => {

    const {onChange, icon, value, grey, isFileInput, iconMargin, backgroundColor, disabled, horizontal, onClick, first, last} = props;
    const style = backgroundColor ? {backgroundColor} : undefined;

    const fileRef = useRef<HTMLInputElement>(null);

    return (
        <button
            disabled={disabled}
            onClick={isFileInput ? () => {
                fileRef && fileRef.current && fileRef.current.click();
            } : onClick}
            className={classNames(styles.modalDialogButton, {
                [styles.modalDialogButtonFirst]: first,
                [styles.modalDialogButtonLast]: last,
                [styles.modalDialogButtonGrey]: grey,
                [styles.modalDialogButtonHorizontal]: horizontal,
            })}
            style={style}>
            <Box center>
                <Box rightMargin={6} center grow>
                    {value}
                </Box>
                {icon && <Box center shrink rightMargin={iconMargin}>
                    <Icon name={icon}/>
                </Box>}
            </Box>
            {
                isFileInput &&
                <input ref={fileRef} style={{display: 'none'}} accept="image/*" type="file" name="file"
                       onChange={(e) => {
                           if (e && e.target && e.target.files && e.target.files.length) {
                               onChange && onChange(e.target.files[0]);
                               if (fileRef && fileRef.current) {
                                   fileRef.current.value = ''
                               }
                           }
                       }}/>
            }
        </button>

    )
};
